import { Link } from 'react-router'
import { HouseMark } from './HouseMark.tsx'

/** The brand lock-up: the house glyph and the two-line wordmark, home link. */
export function Logo() {
	return (
		<Link
			to="/"
			viewTransition
			className="group m-2 flex items-center gap-2.5 rounded-xl p-1.5 leading-none"
			aria-label="Huskonsertfestivalen på Vorrå — til framsida"
		>
			<HouseMark className="ease-spring h-9 w-9 shrink-0 transition-transform duration-500 group-hover:-rotate-3 motion-reduce:transition-none" />
			<span className="grid gap-1">
				<span className="font-display text-[1.05rem] font-semibold tracking-tight [font-variation-settings:'SOFT'_100,'WONK'_1]">
					Huskonsertfestivalen
				</span>
				<span className="text-ember-ink text-[0.68rem] font-bold tracking-[0.22em] uppercase">
					Vorrå
				</span>
			</span>
		</Link>
	)
}
